import { useState, useEffect } from 'react';
import { request } from 'utils/api';

/**
 * Fetches character appearances for a venue + date.
 * Shared by the checkout calendar (DateSchedulePanel) and the CLP
 * OperationalHoursModal so the fetch lives in one place.
 *
 * @param {string|number} venueId
 * @param {string} isoDate - yyyy-MM-dd
 * @returns {Array} appearances ([{ startTime, character, location }, ...])
 */
export const useCharacterAppearances = (venueId, isoDate) => {
  const [appearances, setAppearances] = useState([]);

  useEffect(() => {
    if (!venueId || !isoDate) return;

    let active = true;
    request({
      method: 'GET',
      path: `/1/appearance?venueId=${venueId}&date=${isoDate}`,
    })
      .then((res) => {
        if (active) setAppearances(res.data || []);
      })
      .catch((err) => console.error('Failed to fetch appearances:', err));

    return () => {
      active = false;
    };
  }, [venueId, isoDate]);

  return appearances;
};
